import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ProjectLocationModel } from '../../models/project-location.model';

export const ProjectLocationActions = createActionGroup({
  source: 'PROJECT_LOCATION',
  events: {
    'Reset to Initial state': emptyProps(),
    'Load locations': props<{
      projectId: string
    }>(),
    'Load locations success': props<{
      locations: ProjectLocationModel.LocationDocument[];
    }>(),
    'Load locations fail': emptyProps(),

    'Create location': props<{ projectId: string, payload: ProjectLocationModel.API.CreateLocationDto }>(),
    'Create location success': props<{
      location: ProjectLocationModel.LocationDocument;
    }>(),
    'Create location fail': emptyProps(),

    'Update location': props<{
      locationId: string;
      payload: ProjectLocationModel.API.CreateLocationDto;
    }>(),
    'Update location success': props<{
      location: ProjectLocationModel.LocationDocument;
    }>(),
    'Update location fail': emptyProps(),

    'Request delete location': props<{ locationId: string }>(),
    'Request delete location cancel': emptyProps(),
    'Delete location': props<{ locationId: string }>(),
    'Delete location success': props<{ locationId: string }>(),
    'Delete location fail': props<{ locationId: string }>(),
  },
});
